// Maps AP API values to the numeric enum integers expected by the Outcome Azure Function.
//
// System.Text.Json's JsonStringEnumConverter doesn't reliably apply via [JsonConverter]
// attribute on nullable enum properties (ServiceType?, OutcomeStatus?) — the nullable
// wrapper is not handled when JsonSerializerOptions is constructed manually.
// Sending integers bypasses the issue: numeric → enum deserialization works natively.
//
// ServiceType enum (Outcome.Lib.Models.Request.ServiceType):
//   Copay=0, Bi=1, AntiDiarrheal=2, OngoingSupport=3, InterimAccess=4, FreeDrug=5, ReferralTo=6
//
// OutcomeStatus enum (Outcome.Lib.Models.Request.OutcomeStatus):
//   Approved=0, Pending=1, Denied=2, Completed=3, Discarded=4,
//   Withdrawn=5, Covered=6, NotCovered=7, Archived=8, Unknown=9

// Keys are pre-normalized (lowercase, separators stripped) to match any casing/separator variant.
const CATEGORY_TO_SERVICE_TYPE: Record<string, number> = {
    'copay':               0,
    'adminreimbsupport':   1,
    'otherlimitedsupply':  2,
    'othereducation':      3,
    'freedrug':            5,
    'adminreferralto':     6,
};

const OUTCOME_TO_STATUS: Record<string, number> = {
    'approved':   0,
    'pending':    1,
    'denied':     2,
    'completed':  3,
    'discarded':  4,
    'withdrawn':  5,
    'covered':    6,
    'notcovered': 7,
    'archived':   8,
};

function normalize(s: string): string {
    return s?.toLowerCase().replace(/[-_\s]/g, '') ?? '';
}

export function getServiceType(serviceCategoryDescription: string): number | undefined {
    return CATEGORY_TO_SERVICE_TYPE[normalize(serviceCategoryDescription)];
}

export function getOutcomeStatus(outcome: string): number | undefined {
    return OUTCOME_TO_STATUS[normalize(outcome)];
}

export function isCopayService(serviceCategoryDescription: string): boolean {
    return normalize(serviceCategoryDescription) === 'copay';
}
